module.exports = __webpack_public_path__ + "img/games-21.05390a06.jpg";